import { render, staticRenderFns } from "./SearchCurrencyHeader.vue?vue&type=template&id=c68d8640&"
import script from "./SearchCurrencyHeader.vue?vue&type=script&lang=js&"
export * from "./SearchCurrencyHeader.vue?vue&type=script&lang=js&"
import style0 from "./SearchCurrencyHeader.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports